import Transport from "models/Transport";
import { GenericService, Service } from "./genericService";

class TransportService
  extends GenericService<Transport>
  implements Service<Transport>
{
  constructor() {
    super("api/Transport");
  }
}

export default new TransportService();
